import {
  ABOUT_YOU_STEP,
  CUSTOMIZATION_STEP,
  PLAN_SELECTION_STEP,
} from "./constants.ts";
import type { OnboardingStep } from "./types.ts";

export const StepperDisplayNames: Record<OnboardingStep, string> = {
  [ABOUT_YOU_STEP]: "About you",
  [CUSTOMIZATION_STEP]: "Customization",
  [PLAN_SELECTION_STEP]: "Plan selection",
};
